import React from 'react';
import styled from 'styled-components';


const MenuWrapper = styled.nav`
    width: 100%;
    padding: 1rem 2rem;
    display: flex;
    align-items: center;
`;
const MenuBody = styled.ul`
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
    align-items: center;
`;
const MenuItem = styled.li`
    margin-right: 1.5rem;
    
    &:last-child {
        margin-right: 0; /* Remove margin on the last item */
    }

    a{
        color:black;
        text-decoration: none;
        font-size: 1rem;
        font-weight: 500;
        cursor: pointer;

        &:hover {
            text-decoration: underline; /* Bootstrap-like underline on hover */
        }
    }
`;
export const Menu: React.FC = () =>{
return(
    <MenuWrapper>
        <MenuBody>
            <MenuItem><a href="/halo/dashboard">Dashboard</a></MenuItem>
            <MenuItem><a href="/halo/jargons">Jargons</a></MenuItem>
            <MenuItem><a href="/halo/users">Users</a></MenuItem>
            <MenuItem><a href="/halo/styles">Styles</a></MenuItem>
        </MenuBody>
    </MenuWrapper>
);
};
export default Menu;